/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './role-item-page.component.html';

import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {RoleModel} from './role-api.service';
import {AdminResourcePagesModule} from '../../common/controller/admin-resource-pages.module';
import {RoleAnalysisPageComponent} from './role-analysis-page.component';
import {RoleEditPageComponent} from './role-edit-page.component';
import {CommonModule} from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, AdminResourcePagesModule, RoleAnalysisPageComponent, RoleEditPageComponent],
  selector: 'adn-role-item-page',
  template
})
export class RoleItemPageComponent {
  @Input() state: SignalAdminResourcePageState<RoleModel>;
}
